import { useVisualEffects } from "./useVisualEffects";
import {
  readVisualEffects,
  type VisualEffectsLevel,
} from "./visualEffectsPreference";

export function motionPolicy(
  level: VisualEffectsLevel,
  reducedMotion: boolean,
) {
  const enabled = level !== "off" && !reducedMotion;
  return {
    enabled,
    stateDuration: enabled ? (level === "lite" ? 100 : 160) : 0,
    duration: enabled
      ? level === "lite"
        ? 120
        : level === "rich"
          ? 240
          : 200
      : 0,
    distance: enabled && level !== "lite" ? (level === "rich" ? 8 : 6) : 0,
    viewTransition: enabled && level !== "lite",
    easing: "cubic-bezier(0.16, 1, 0.3, 1)",
  };
}

export function useMotionPolicy() {
  const { level, reducedMotion } = useVisualEffects();
  return motionPolicy(level, reducedMotion);
}

// Read current preferences across independently loaded app copies.
export function readMotionPolicy() {
  return motionPolicy(
    readVisualEffects(),
    typeof window !== "undefined" &&
      Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches),
  );
}
